import { EventType } from './Event.model';
import { DifferenceFormat } from '~/Models/DTO/Time.model';

export const EventGroupDefaultValue = {
  publicCancellationRefundEndAsNumber: 0,
  publicCancellationRefundEndType: DifferenceFormat.HOURS,
  publicBookingWindowStartType: DifferenceFormat.HOURS,
  publicBookingWindowEndType: DifferenceFormat.HOURS,
  publicCancellationWindowEnd: '0.00:00:00',
};

export interface EventGroup {
  id: string;
  numericId: number;
  providerId: string;
  name: string;
  description: string;
  color: string;
  public: boolean;
  archived: boolean;
  seats: number;
  type: EventType;
  categoryType: EventType;
  originalImageUrl: string;
  imageUrl: string;
  locationId: string;
  trainerIds: string[];
  bookingGroupIds: string[];
  waitingListEnabled: boolean;
  multipleBookingEnabled: boolean;
  publicBookingWindowStart: string;
  publicBookingWindowEnd: string;
  publicCancellationEnabled: boolean;
  publicCancellationWindowStart: string;
  publicCancellationWindowEnd: string;
  publicCancellationRefundEnd: string;
  deleted: string;
  categoryId: number;
  livestream: boolean;
  source: string | null;
}
